import React from "react";
import "./button.css";
import Spinner from "react-bootstrap/Spinner";
import useTranslator from "../../../hooks/useTranslator";

const Button = ({
  size = "medium",
  label,
  onClick,
  loading,
  className,
  icon,
  disabled,
  type = "button",
}) => {
  const { _t } = useTranslator();

  return (
    <button
      type={type}
      className={`${className} cmn_btn btn-${size} ${
        (loading || icon) ? "d-flex gap-2 align-items-center" : ""
      }`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {icon && icon}
      {label}
      {loading && (
        <Spinner animation="border" role="status">
          <span className="visually-hidden">
            {_t("loading", "Loading...")}
          </span>
        </Spinner>
      )}
    </button>
  );
};

export default Button;
